import { Box, Center, Image } from "@chakra-ui/react";
import { toAbsoluteUrl } from "../../helpers";

export default function SplashScreen() {
  return (
    <Center h="100vh" w="100vw" pos="relative">
      <Box w="60" bg="white" rounded="full">
        <Image w="full" pos="sticky" src={toAbsoluteUrl("/assets/logo.png")} />
      </Box>
    </Center>
  );
}
